export enum PlanningViewType {
    GENERAL = 0,
    BOGGING = 1,
    DRILLING = 2,
}
